<template lang="jade">
  .container-fluid
    .row
      .profile_main.col-md-12
        header.profile_title_bar.main_title_bar.clearfix
          h1.title.col-md-10.col-sm-3.col-xs-3.clearfix
            | Preset
            //- span {{profiles | json}}
        section.profile_content.row_space--xs.clearfix
          .table-responsive(v-if="isMobile")
            table.profile_table_mobile.col-centered.table.table-bordered.table-striped.table-hover
              tr
                th No.
                th Name
                th Detail/Preview
              tr(v-for='(key, profile) in profiles')
                td {{key}}
                td {{profile.name}}
                td
                  i.fa.fa-info-circle.fa-lg(v-on:click='handleShowModal(key)')
                  i.fa.fa-picture-o.fa-lg(v-on:click='handleShowGraphPreview(key)')
          .col-md-10.col-centered(v-else)
            table.profile_table.conl-centered.table.table-bordered.table-striped.table-hover
              tr
                th No.
                th Name
                th Resolution
                th Preview
                th Detail
              tr(v-for='(key, profile) in profiles')
                td {{key}}
                td {{profile.name}}
                td {{profile.resolution}}
                  //- span {{profile.split | json}}
                td.screen_preview
                  v-screen(
                    v-bind:editable='false'
                    v-bind:show-link='false'
                    v-bind:in-which-page="'preset'"
                    v-bind:show-ps-in="false"
                    v-bind:id="key"
                  )
                td
                  i.fa.fa-info-circle.fa-lg(v-on:click='handleShowModal(key)')
      modal.single_profile_edit_modal(
        v-bind:callback='handleApply'
        v-bind:show.sync='showEditModal'
        v-bind:title.sync='editingProfile.title'
        effect='zoom'
        ok-text='Apply'
        cancel-text='Cancel'
      )
        .modal-body(slot='modal-body')
          table.profile_config_table.col-centered.table.table-bordered.table-hover
            tr
              th Name
              td
                input.form-control(v-model='editingProfile.name' maxlength=7 disabled)
            tr
              th Resolution
              td {{editingProfile.resolution}}
            tr
              th Split
              td
                section.split_group.col-xs-12.clearfix.no_pad-xs
                  .split__single.col-xs-12.no_pad(v-for='(key, value) in editingProfile.split' v-bind:data-index='key')
                      label.col-xs-12.col-md-4 Window {{winNameAry[key]}}
                      .col-xs-6.h_start.clear-left
                        input.form-control.col-xs-6(v-model='value[0]' type='number' disabled)
                      .col-xs-6.h_end
                        input.form-control.col-xs-6(v-model='value[2]' type='number' disabled)
                      .col-xs-6.v_start
                        input.form-control.col-xs-6(v-model='value[1]' type='number' disabled)
                      .col-xs-6.v_end
                        input.form-control.col-xs-6(v-model='value[3]' type='number' disabled)
        .modal-footer(slot='modal-footer')
          button.btn.btn-default(v-on:click='showEditModal = false') Cancel
      modal.single_screen_preview_modal(
        v-bind:callback=''
        v-bind:show.sync='showPreviewModal'
        v-bind:title.sync='previewProfile.title'
        effect='zoom'
        ok-text='Apply'
        cancel-text='Cancel'
        large
      )
        .modal-body.no_pad(slot='modal-body')
          .screen_group
            v-screen(
              v-if='showPreviewModal'
              v-bind:editable='false'
              v-bind:show-link='false'
              v-bind:in-which-page="'preset'"
              v-bind:show-ps-in="true"
              v-bind:id.sync="previewProfile._id")
        .modal-footer(slot='modal-footer')

</template>
<script>
// import { call } from 'src/Service.js'
import { modal } from 'vue-strap'
import singleSelect from 'src/components/Single-Select.vue'
import scr from '../../components/VWScreen.vue'
import _ from 'lodash'
import $ from 'jquery'

import { mapGetters } from 'vuex'

export default {
  components: {
    modal,
    'v-select': singleSelect,
    'v-screen': scr
  },
  data () {
    return {
      showTestAPI: false,
      showEditModal: false,
      showPreviewModal: false,
      editingProfile: {
        _id: '',
        title: '',
        name: '',
        resolution: '',
        split: {
          '1': [],
          '2': [],
          '3': [],
          '4': []
        }
      },
      winNameAry: ['', 'A', 'B', 'C', 'D'],
      outLayout: 'custom',
      label: {},
      // splitsAry: {
      //   '1': {},
      //   '2': {},
      //   '3': {},
      //   '4': {},
      //   '5': {},
      //   '6': {},
      //   '7': {},
      //   '8': {}
      // },
      previewProfile: {
        title: '',
        _id: ''
      }
    }
  },
  async asyncData () {
    let { mac } = this.$route.params
    this.$store.dispatch('fetchData', mac)
    // let newProfile = {}
    // let newSplitsAry = {}
    //
    // // save profile in $root to speed up
    // if (!this.$root.mixerProfile) {
    //   this.$root.mixerProfile = {}
    // }
    //
    // if (!this.$root.mixerProfile[mac]) {
    //   try {
    //     for (let i = 1; i < 9; i++) {
    //       console.log(i)
    //       let { profiles } = await call(mac, 'dxGetProfiles', {
    //         profile: i.toString()
    //       })
    //       newProfile[i] = profiles
    //       newSplitsAry[i] = {
    //         setting: profiles.split
    //       }
    //     }
    //
    //     this.profiles = _.cloneDeep(newProfile)
    //     this.splitsAry = _.cloneDeep(newSplitsAry)
    //     this.$root.mixerProfile[mac] = newProfile
    //   } catch (err) {
    //     console.error(err)
    //   }
    // } else {
    //   this.profiles = _.cloneDeep(this.$root.mixerProfile[mac])
    //   for (let i = 1; i < 9; i++) {
    //     newSplitsAry[i] = {
    //       setting: this.profiles[i].split
    //     }
    //   }
    //   this.splitsAry = _.cloneDeep(newSplitsAry)
    // }
  },
  computed: {
    ...mapGetters({
      isFetching: 'getIsFetching',
      profiles: 'getProfiles',
      isMobile: 'getIsMobile'
    })
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    handleShowGraphPreview (key) {
      console.log('handle show graph preview' + key)
      this.previewProfile._id = key
      this.previewProfile.title = `Preset ${key} graph preview`
      this.showPreviewModal = true
      setTimeout(() => {
        this.$broadcast('render', key)
      }, 50)
    },
    handleShowModal (key) {
      this.editingProfile._id = key
      this.editingProfile.title = `Preset ${key} detail`
      this.editingProfile.resolution = this.profiles[key].resolution
      this.editingProfile.name = this.profiles[key].name
      this.editingProfile.split = this.profiles[key].split
      this.showEditModal = true
    },
    handleApply () {
      // // validate the cords
      // let rex = /^-{0,1}[0-9]+/
      // for (let i in this.editingProfile.split) {
      //   for (let j in this.editingProfile.split[i]) {
      //     // check valid numbers
      //     if (!rex.test(parseInt(this.editingProfile.split[i][j]))) {
      //       return this.alert('danger', '', 'Please enter valid numbers')
      //     }
      //     // check x' no larger than x
      //     if (j > 1 && j < 4 && parseInt(this.editingProfile.split[i][j]) < parseInt(this.editingProfile.split[i][j - 2])) {
      //       return this.alert('danger', '', 'First split of each row can not be larger than the second.')
      //     }
      //   }
      // }
      //
      // let { mac } = this.$route.params
      // let params = {
      //   profiles: {
      //     [this.editingProfile._id]: {
      //       name: this.editingProfile.name,
      //       mapping: this.editingProfile.mapping,
      //       split: this.editingProfile.split,
      //       layer: this.editingProfile.layer
      //     }
      //   }
      // }
      // call(mac, 'dxSetProfiles', params).then(res => {
      //   this.updateRootMixerProfile(this.editingProfile._id)
      //   let newSplitsAry = _.cloneDeep(this.splitsAry)
      //
      //   newSplitsAry[this.editingProfile._id].setting = params.profiles[this.editingProfile._id].split
      //
      //   this.splitsAry = _.cloneDeep(newSplitsAry)
      //   this.showEditModal = false
      //
      //   setTimeout(() => {
      //     this.$broadcast('render', this.editingProfile._id)
      //     this.$broadcast('chgZindex', this.profiles[this.editingProfile._id].layer, this.editingProfile._id)
      //   }, 300)
      // }).catch(err => {
      //   this.alert('danger', '', err)
      // })
    },
    onSortEnd (event) {
      let newLayer = []
      let newEditing = _.cloneDeep(this.editingProfile)
      $.each($('.dragItem'), (i, val) => {
        newLayer.push(parseInt($(val).attr('data-index')))
      })
      newEditing.layer = _.cloneDeep(newLayer)
      this.editingProfile = _.cloneDeep(newEditing)
    }
  }, // close methods
  ready () {
  },
  watch: {
    showEditModal (nv) {
      if (!nv) {
        $('.single_profile_edit_modal').scrollTop(0)
      }
    },
    isFetching (nv) {
      if (!nv) this.$broadcast('render', 'all')
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      console.log('got event:', type)
      switch (type) {
        case 'preset':
          let key = Object.keys(event)[0]
          // console.log('key in event', key)
          // console.log(event)
          this.$store.dispatch('updatePreset', event)
          setTimeout(() => {
            this.$broadcast('render', key)
          }, 700)
          break
      }
    }
  }
}
</script>
<style lang="scss" scope>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
.fa{
  cursor:pointer;
}
// table &mobile table
.profile_table_mobile{
  &, th{
    text-align:center;
  }
  .fa-info-circle{
    margin-right: 20px;
  }
}
.profile_table{
  &, th{
    text-align:center;
  }
  td.screen_preview{
    padding-top:1px; // td default is padding-top: 8px; minus 7px in screen.vue
  }
  .mapping__single, .split__single, .layer__single{
    span{
      color:$base_white;
      padding:6px 10px;
    }
    @each $i in $window_colors{
      &[data-bgColor='#{nth($i, 1)}']{
        span {
          background-color: nth($i, 2) ;
        }
      }
    }
  }
}
// .sortable
.token{
  outline: 1px solid $pri_gray;
}
.sortable-fallback{
  display: none;
}
.sortable-chosen{
  & .token{
    outline: 2px solid $pri_dark;
  }
}
ul.dropzone{
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

li.dragItem{
  text-align: center;
  color: $base_white;
  .token{
    height: 25px;
    line-height: 25px;
  }
  @each $i in $window_colors{
    &[data-bgColor='#{nth($i, 1)}']{
      .token{
        background-color: nth($i,2);
      }
    }
  }
  &.focusMenu{
    border: 1px solid $base_black;
    color: $base_black;
  }
  &.disabled{
    opacity: .5;
  }
}
// modal
.single_profile_edit_modal{
  .split__single{
    padding-top: $space_xxs;
    @each $i in $window_colors{
      &[data-bgColor='#{nth($i, 1)}']{
        label{
          color:$base_white;
          background-color: nth($i,2);
          text-align:center;
        }
      }
    }
  }
  .name{
    padding-left: 0;
    @include breakpoint(iFive) {
      padding-right:10px;
    }
  }
}

.split__single{
  position: relative;
  padding-left: 25px;
  padding-right: 0px;
  & .h_start::before{
    content: 'H:';
  }
  & .h_end::before, .v_end::before{
    content: 'To';
  }
  & .v_start::before{
    content: 'V:';
  }

  & .h_start, .h_end, .v_start, .v_end{
    position: relative;
    padding-left: 20px;
    padding-right: 5px;
    &::before{
      position: absolute;
      display: block;
      left: 0px;
      top: 7px;
    }
    & .form-control{
      padding: 3px;
      text-align:center;
    }
  }
}


</style>



// WEBPACK FOOTER //
// Profile.vue?b09b529c